import React from "react";
import { makeStyles, Typography, Container, Grid } from "@material-ui/core";

export const FilterGroupContainer = (props: any) => {
  const classes = useStyles();
  const { count, letter } = props;
  return (
    <Container className={classes.root}>
      <Grid container xs={12} alignItems="center" justifyContent="flex-start">
        <Typography
          variant="subtitle2"
          component="p"
          color="textPrimary"
          className={classes.letter}
        >
          {letter}
        </Typography>
        <Typography
          variant="caption"
          component="p"
          color="textSecondary"
          className={classes.caption}
        >
          {count + " Shop"}
        </Typography>
      </Grid>
      <Grid container xs={12} className={classes.childerenContainer}>
        {props.children}
      </Grid>
    </Container>
  );
};
const useStyles = makeStyles({
  root: {
    paddingLeft: 16,
  },
  letter: {
    textTransform: "uppercase",
  },
  caption: {
    marginLeft: 8,
  },
  childerenContainer: {
    marginTop: 12,
  },
});
